import React, { Component } from 'react';

class ContactUs extends Component {

    render() { 
        return ( 
            <div>
                <h1>Contact us</h1>
                
            </div>
         );
    }
}
 
export default ContactUs;